// lib
import Node from 'ln/node/Node';
import { ScrollInfo } from 'ln/node/Window';
import Window from 'ln/node/Window';
import Template from 'ln/template/TemplateManager';


class Panel {

	private node:Node;

	private orgContent:Array<Node>;
	private orgScrollPos:ScrollInfo;
	private orgWhere:Node;

	constructor( template:string = "krw.panel" ) {
		this.render( template );
	}

	private render( template:string ) {
		this.node = Node.fromHTML( Template.render( template ) );

		this.node.js( 'back-btn' ).click.add( this.onBack, this );
	}

	/**
	 * Shows the given what node in the panel and places it into the where node.
	 */
	show( what:Node, where?:Node ) {


		// store all original infos
		this.orgWhere = ( where ) ? where : Node.fromNative( document.body );
		this.orgScrollPos = Window.scrollInfo();
		this.orgContent = where.children();
		where.empty();

		// set the content on the panel
		var content = this.node.js( 'content' );
		content.empty();
		content.append( what );

		// place the panel content at the where node
		where.append( this.node );

		// and scroll to top
		window.scrollTo( 0, 0 );
	}


	/**
	 * Hides the panel and shows the original content again
	 */
	hide() {
		this.node.remove();

		this.orgContent.forEach( ( node ) => {
			this.orgWhere.append( node );
		});

		window.scrollTo( this.orgScrollPos.left, this.orgScrollPos.top );
	}

	/**
	 * Callback when the back button was pressed
	 */
	private onBack() {
		this.hide();
	}
}


export default Panel;